function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "invoices_x5F_pound"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141.735 0H35.433v283.465h212.599V92.122L141.735 0zm14.17 49.79l32.49 28.211h-32.49v-28.21zM63.784 255.125V28.34h63.78v78.002h92.122v148.782H63.783z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.877 212.976v20.683H92.3v-20.682c10.347 0 16.135-4.56 16.135-17.001v-7.749H92.3v-12.561h16.135V162.61c0-21.669 17.975-34.23 44.084-34.23 26.717 0 39.278 13.042 40.511 31.39h-25.616c-.98-6.52-5.294-12.187-16.128-12.187-10.221 0-15.515 5.053-15.515 15.761v12.32h37.804v12.562H135.77v9.974c0 6.642-1.48 10.95-4.434 14.775h63.54z"
}))));